import { PlansManager } from './plans-manager';
import { PlansManagerProvider } from './plans-manager.provider';

export const FeaturePlansManager = () => {
   return (
      <PlansManagerProvider >
         <PlansManager></PlansManager>
      </PlansManagerProvider >
   );
};
